import React, { useEffect, useState, useContext } from 'react'
import { language } from '../../App'
import LocationsLightbox from '../../components/LocationsLightbox/LocationsLightbox'
import './Locations.scss'
import { Fetcher } from '../../helpers/api/Fetcher'
import { Col, Container, Row } from 'react-bootstrap';

const Locations = () => {
  const { currentLanguage } = useContext(language)
  const [isLoading, setIsLoading] = useState(false)
  const [data, setData] = useState([])

  useEffect(() => {
    const fecthApi = async () => {
      const URL = `https://beta.haromstudio.hu/scriptedprod/wp-json/wp/v2/pages/466?_embed&acf_format=standard`;
      const res = await Fetcher({ URL, setIsLoading })
      
      setData(res)
      
      setIsLoading(false)
    }
    
    fecthApi()
  }, [currentLanguage])

  if (!isLoading && data.acf) {
  return (
    <main className='service-production--locations'>
        <Container>
          <Row>
            <Col xs={12}>
              <div dangerouslySetInnerHTML={{ __html: data.content.rendered }} className='mt-3 lead-block'></div>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
                <LocationsLightbox />
            </Col>
          </Row>
        </Container>
    </main>
  )
  } else {
    return (
      <main className='body'></main>
    )
  }
}

export default Locations